module.exports = __webpack_public_path__ + "dc723c608dd2c0401798a8225cb13552.pdf";